'use strict';

var processInclude = require('base/util');

$(document).ready(function() {
    processInclude(require('./experience/storepage'));
    processInclude(require('./product/quickView'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/notifyme'));
});